import Axios from "axios";
import token from "./setToken";

export default {

  async selectList() {
    try {
      // await token.checkToken();
      const res = await Axios.get("/api/MdistrictSelectList", token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("集計地区一覧を取得できません[selectList]");
      throw error;
    }
  },

};
